






































































































































import OtTableHeader from '@/components/global/table/ot-table-header.vue';
import OtTable from '@/components/global/table/ot-table.vue';
import OtApi, { executeApi } from '@/services/api.service';
import { OtUserAction } from '@/types/action-enums';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IColumnData } from '../../global/table/ot-table-models';
import { handleHeaderClick } from '../../global/table/ot-table-utils';
import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '../document-models';

import { ROUTE_WORKFLOW_DOCUMENT, ROUTE_WORKFLOW_DOCUMENT_ASSOCIATIONS } from '@/areas/claims/claims-routes';
import {
  ROUTE_CONTRACT_DOCUMENT,
  ROUTE_CONTRACT_DOCUMENT_ASSOCIATIONS,
} from '@/areas/projects/contracts/contract-routes';
import { ROUTE_GLOBAL_DOCUMENT, ROUTE_GLOBAL_DOCUMENT_ASSOCIATIONS } from '@/areas/documents/documents-routes';
import { ROUTE_PROJECT_DOCUMENT, ROUTE_PROJECT_DOCUMENT_ASSOCIATIONS } from '@/areas/projects/projects-routes';
import {
  ROUTE_SETTINGS_ORG_DOCUMENT,
  ROUTE_SETTINGS_ORG_DOCUMENT_ASSOCIATIONS,
} from '@/areas/settings/settings-routes';
import OtDocumentAssociations from '@/components/documents/ot-document-associations/ot-document-associations.vue';
import OtButton, { OtBtnSize, OtBtnStyle, OtBtnType } from '@/components/global/ot-button.vue';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import { PostUpdateDocumentAssociationsRequestModel } from '@/services/generated/api';
import { getAconexDocumentLink, getAconexMailLink } from '@/utils/aconex-utils';
import { formatDateAndTime } from '@/utils/date-utils';
import { areSame } from '@/utils/string-utils';
import { RawLocation } from 'vue-router';
import {
  DocumentAssociation,
  DocumentListItem,
  DocumentSearchResult,
  DocumentsSegmentInstanceAssociation,
} from './document-list-models';

interface IMenuOption {
  key: string;
  label: string;
  onClick: (contract: DocumentListItem) => void;
  disabled?: boolean;
}

@Component({
  components: {
    OtTable,
    OtTableHeader,
    OtButton,
    OtLoadingSpinner,
    OtDocumentAssociations,
  },
})
export default class OtDocumentList extends Vue {
  // * PROPS
  @Prop() private filters?: DocumentsFilter;
  @Prop() private level!: DocumentListLevel;
  @Prop() private mode!: DocumentListMode;
  @Prop() private organisationGid?: string;
  @Prop() private projectGid?: string;
  @Prop() private contractGid?: string;
  @Prop() private segmentInstanceGid?: string;
  @Prop() private locationDescription?: string;

  // * REFS

  // * DATA
  private loadTime = new Date();
  private api = new OtApi();
  private buttonSize = OtBtnSize.Tiny;
  private buttonStyle = OtBtnStyle.Outline;
  private buttonType = OtBtnType.Icon;

  private tableColumnsBase: IColumnData[] = [
    {
      index: 0,
      label: '',
      key: 'selectorColumn',
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 1,
      label: 'Document',
      key: 'Name', // don't change this, the API expects this exact string for the sorting
      isActive: true,
      ascending: true,
      sortable: true,
    },
    {
      index: 2,
      label: 'Type',
      key: 'AssociationType',
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 3,
      label: 'Document Content',
      key: 'ContentDescription', // don't change this, the API expects this exact string for the sorting
      isActive: false,
      ascending: false,
      sortable: true,
    },
    {
      index: 4,
      label: 'Document Date',
      key: 'Date', // don't change this, the API expects this exact string for the sorting
      isActive: false,
      ascending: false,
      sortable: true,
    },
    {
      index: 5,
      label: 'Associated to',
      key: 'AssociatedTo',
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 6,
      label: '',
      key: 'actionMenu',
      isActive: false,
      ascending: false,
      sortable: false,
    },
  ];
  private tableColumns: IColumnData[] = [];

  @Watch('mode')
  private modeChanged() {
    this.initTableColumns();
  }
  // @Watch('level')
  // private levelChanged() {
  //   this.initTableColumns();
  // }

  private initTableColumns() {
    const includeActionMenu = this.mode === DocumentListMode.Display;
    const includeSelectorColumn = this.mode === DocumentListMode.Select;
    const includeTypeColumn = this.isLevelWorkflow;
    const includeAssociationsColumn = !this.isLevelWorkflow;
    this.tableColumns = this.tableColumnsBase.filter(
      c =>
        (includeActionMenu || c.key !== 'actionMenu') &&
        (includeSelectorColumn || c.key !== 'selectorColumn') &&
        (includeTypeColumn || c.key !== 'AssociationType') &&
        (includeAssociationsColumn || c.key !== 'AssociatedTo'),
    );
  }

  private get isModeSelect() {
    return this.mode === DocumentListMode.Select;
  }
  private get isLevelWorkflow() {
    return this.level === DocumentListLevel.Workflow;
  }
  private get documentLinkTarget() {
    return this.isModeSelect ? '_blank' : '_self';
  }

  private activeColumn = this.tableColumnsBase[1];
  private page = 1;
  private rowLoadingStates: { [key: string]: boolean } = {};
  private results = DocumentSearchResult.createEmpty();
  private selectedResults: DocumentListItem[] = [];

  // * COMPUTED
  private get levelName() {
    return DocumentListLevel[this.level];
  }
  private get modeName() {
    return DocumentListMode[this.mode];
  }

  private get resultsWithSelection() {
    // we need to combine the results with the selected items
    // selected items that are not in the results are shown first
    // then, results are shown
    console.log('ot-document-list -> resultsWithSelection -> this.selectedResults:  ', this.selectedResults);
    return [...this.selectedResults.filter(x => !this.results.items.some(y => y.gid === x.gid)), ...this.results.items];
  }

  // * WATCHERS
  @Watch('filters')
  private filtersChanged() {
    console.log('ot-documents-list -> filtersChanged -> filters:  ', this.filters);
    // go back to the first page
    this.updateCurrentPage(1);
  }

  // * METHODS
  private debugValue(val: unknown | null | undefined) {
    if (val === undefined) {
      return 'undefined';
    }
    return JSON.stringify(val);
  }

  private updateCurrentPage(value: number) {
    // reload the new page of results
    this.page = value;
    this.loadResults();
  }
  private headerClick(header: IColumnData) {
    const handledHeaders = handleHeaderClick(this.tableColumns, this.activeColumn, header);
    this.tableColumns = handledHeaders.tableColumns;
    this.activeColumn = handledHeaders.activeColumn;
    // go back to the first page
    this.updateCurrentPage(1);
  }
  private isLoading = false;

  private mostRecentLoadKey: symbol | null = null;
  private async loadResults() {
    this.isLoading = true;
    const effectiveOrganisationGids = [...(this.filters?.organisationGids ?? [])];
    const effectiveProjectGids = [...(this.filters?.projectGids ?? [])];
    const effectiveContractGids = [...(this.filters?.contractGids ?? [])];
    const effectiveSegmentInstanceGids: string[] = [];
    // we only want to add the "from here down" association filter if there's no other filter
    // Otherwise, if we're viewing documents for An Organisation, and the user says "filter to this project"
    // then we send "org = 1 OR project = 2" to the server
    // and that then looks like the filter by project didn't work, because the other org documents (including for different projects) come back matching the "org = 1" bit of it
    const hasSomeSortOfAssociationFilter = Boolean(
      effectiveOrganisationGids.length ||
        effectiveProjectGids.length ||
        effectiveContractGids.length ||
        effectiveSegmentInstanceGids.length,
    );
    console.log('ot-document-list -> loadResults -> hasSomeSortOfAssociationFilter:  ', {
      hasSomeSortOfAssociationFilter,
      effectiveOrganisationGids,
      effectiveProjectGids,
      effectiveContractGids,
      effectiveSegmentInstanceGids,
    });
    if (!hasSomeSortOfAssociationFilter) {
      if (this.level === DocumentListLevel.Organisation && this.organisationGid) {
        effectiveOrganisationGids.push(this.organisationGid);
      }
      if (this.level === DocumentListLevel.Project && this.projectGid) {
        effectiveProjectGids.push(this.projectGid);
      }
      if (this.level === DocumentListLevel.Contract && this.contractGid) {
        effectiveContractGids.push(this.contractGid);
      }
      if (this.level === DocumentListLevel.Workflow && this.segmentInstanceGid) {
        effectiveSegmentInstanceGids.push(this.segmentInstanceGid);
      }
    }
    // the key is optional and not needed, but I feel like it's nice to give it a description
    const thisRequestLoadKey = Symbol('document-list-load');
    this.mostRecentLoadKey = thisRequestLoadKey;

    const result = await this.api.documents().getSearchDocuments(
      effectiveOrganisationGids, // @param organisationGids (optional) Public ids of Organisations to search Documents by Association
      effectiveProjectGids, // @param projectGids (optional) Public ids of Projects to search Documents by Association
      effectiveContractGids, // @param contractGids (optional) Public ids of Contracts to search Documents by Association
      effectiveSegmentInstanceGids, // @param segmentInstanceGids (optional) Public ids of Segment Instances to search Documents by Association
      this.filters?.includeMyUnassociatedDocuments ?? false, // @param includeMyUnassociatedDocuments (optional) Whether to include documents that the current user has created that are not associated with anything.
      this.filters?.keyword, // @param keyword (optional) Keyword text to search Documents by Document Name
      this.filters?.contentDescriptions, // @param contentDescriptions (optional) Content Description texts to search Documents by Document Content Description
      this.filters?.dateFrom ? this.filters.dateFrom.toZonelessDateFormat() : undefined, // @param fromDocumentDate (optional) Start Date to search Documents by Document Date (Inclusive)
      this.filters?.dateTo ? this.filters.dateTo.toZonelessDateFormat() : undefined, // @param toDocumentDate (optional) End Date to search Documents by Document Date (Inclusive)
      this.filters?.documentSource.length ? this.filters.documentSource : undefined, // @param documentSources (optional) Array of types of documents to retrieve. Terms to be OR'd together - ie: if OneTrack and AconexDocument are passed, then documents that have no metadata at all, or documents that have aconex document metadata will be returned. Documents that have aconex mail metadata will not
      this.activeColumn.key, // @param orderBy (optional) Column to order by
      !this.activeColumn.ascending, // @param orderDesc (optional) Order by descending or not
      20, // @param pageSize (optional) Pagination size
      this.page, // @param pageNumber (optional) Page number of paginated data to return. 1 based.
    );
    console.log('ot-documents-list -> loadData -> result:  ', result);
    if (this.mostRecentLoadKey !== thisRequestLoadKey) {
      // Another request has been made - the module level variable has been set to something else
      // Drop these results on the floor
      // Don't worry about setting isLoading either, we know there is another request happening
      console.log('ot-documents-list -> loadData -> ignoring result because another load has started');
      return;
    }

    const results = DocumentSearchResult.createFromApiResponse(result);
    if (!this.isModeSelect) {
      // we only want to do this if we're not in select mode. it's too confusing otherwise
      results.items = this.bustOutVersions(results.items);
    }
    for (const item of results.items) {
      item.isSelected = !item.isOutdatedVersion && this.selectedResults.some(x => x.gid === item.gid);
    }
    this.results = results;
    this.isLoading = false;
  }
  private bustOutVersions(items: DocumentListItem[]) {
    /*
      We've got an issue with documents and workflow associations.
      A document can be associated with multiple things. Orgs, projects, contracts, workflows.
      The first 3 are fine, it's just the document that is associated. No version involved. Edit the document and make a new version, it's still the same association.
      Workflows are the odd one out. Once a version is associated with a workflow, it is forever associated, regardless of newer versions.
      The info in the columns can be edited when making a new version. This means we might have V1 on a workflow with a title of "foo"
      Then they edit the document, V2 has a new title "FooBar".
      Without making up these fake rows, we end up saying V1 of the document is associated with the workflow, and we put FooBar in the title column. This is misleading.
      So, we need to make up these fake rows.
      We need to make a row for each version of the document that has workflow associations.

      Few scenarios for documents
      * No workflow links. Don't care. Show single document row. This is the easy happy path
      * Workflow links, but to current version. Show single row. Similar happy path.
      * Workflow links to multiple versions. Show one row per version.
      * Workflow link to older version only. No links to newest version. Uh... ? 
          Do we have one row or two here? Do we have "this is the newest" and no associations, as well as the older version? 
          Feels correct to have the newest version, and the older version.
          Turns out this was wrong. It wigged Jack out, which wigged Phil out.
          We actually won't add the most recent version to the list if it doesn't have any associations to this workflow
    */
    const results: DocumentListItem[] = [];
    for (const item of items) {
      // we probably need the item there. We'll remove it if we don't
      results.push(item);

      // get all of the workflow associations that are not the current version
      const workflowAssociationsForOlderVersions = item.segmentInstanceAssociations.filter(
        a => a.documentVersionIndex < item.versionIndex,
      );
      // if there's nothing for older version, move onto the next item
      if (!workflowAssociationsForOlderVersions.length) {
        continue;
      }

      // group them up by the version number. We only want one fake row per version
      const workflowAssociationsByVersion = workflowAssociationsForOlderVersions.reduce((acc, curr) => {
        if (!acc[curr.documentVersionIndex]) {
          acc[curr.documentVersionIndex] = [];
        }
        acc[curr.documentVersionIndex].push(curr);
        return acc;
      }, {} as Record<number, DocumentsSegmentInstanceAssociation[]>);

      // now, for each version, create a new item, give it its associations, remove the associations from the original item
      for (const associations of Object.values(workflowAssociationsByVersion)) {
        // special case for workflow mode. We only want to bust out associations for the current workflow. The rest can stay with the parent
        // otherwise it looks weird, with unrelated workflow's older assocations on their own row here
        // Also, we'll be removing anything that doesn't have an association to this workflow
        // further down, so we don't need to worry about making a whole new row, just to remove it later
        if (this.isLevelWorkflow) {
          if (!associations.some(a => a.associatedGid === this.segmentInstanceGid)) {
            continue;
          }
        }
        const newItem = DocumentListItem.createForOlderVersion(item, associations);
        results.push(newItem);
        // remove the associations from the original item
        item.segmentInstanceAssociations = item.segmentInstanceAssociations.filter(
          a => !associations.some(b => b.gid === a.gid),
        );
      }
    }
    // two different final passes
    // For workflows, we only want to show rows that are actually associated to this workflow. Otherwise the most recent version row shows up, but it has no association type
    // and looks weird.
    if (this.isLevelWorkflow) {
      return results.filter(item =>
        item.segmentInstanceAssociations.some(a => a.associatedGid === this.segmentInstanceGid),
      );
    } else {
      // for everything else, we just want to show rows that have associations
      // otherwise you can end up with the most recent version not having any associations at all, and an older version
      // being associated to a workflow. The newer version row is not needed, we have the "this is out of date" icon on the older row
      // It might wig the users out if they don't see the newest version row there as well, but they can click on it to see what is going on
      // We also need to include legit orphaned rows here
      return results.filter(
        item =>
          item.isOrpaned ||
          item.segmentInstanceAssociations.length > 0 ||
          item.organisationAssociations.length > 0 ||
          item.projectAssociations.length > 0 ||
          item.contractAssociations.length > 0,
      );
    }
  }

  private getAssociationTypeForItem(item: DocumentListItem) {
    if (!this.segmentInstanceGid) {
      return null;
    }
    const association = item.segmentInstanceAssociations.find(a => a.associatedGid === this.segmentInstanceGid);
    if (!association) {
      return null;
    }
    return association.associationType.name;
  }

  private formatDate(date: Date | null) {
    if (date) {
      return formatDateAndTime(date, { excludeTime: true });
    }
    return '';
  }

  private getDocumentRoute(document: DocumentListItem): RawLocation {
    const query = document.isOutdatedVersion
      ? { version: document.segmentInstanceAssociations[0].documentVersionIndex.toString() }
      : undefined;
    switch (this.level) {
      case DocumentListLevel.Organisation:
        return {
          name: ROUTE_SETTINGS_ORG_DOCUMENT,
          params: { orgId: this.organisationGid ?? '', documentGid: document.gid },
          query,
        };
      case DocumentListLevel.Project:
        return {
          name: ROUTE_PROJECT_DOCUMENT,
          params: { projectGid: this.projectGid ?? '', documentGid: document.gid },
          query,
        };
      case DocumentListLevel.Contract:
        return {
          name: ROUTE_CONTRACT_DOCUMENT,
          params: { projectGid: this.projectGid ?? '', contractGid: this.contractGid ?? '', documentGid: document.gid },
          query,
        };
      case DocumentListLevel.Workflow:
        return {
          name: ROUTE_WORKFLOW_DOCUMENT,
          params: {
            projectGid: this.projectGid ?? '',
            contractGid: this.contractGid ?? '',
            claimGid: this.segmentInstanceGid ?? '',
            documentGid: document.gid,
          },
          query,
        };
      case DocumentListLevel.Global:
        return {
          name: ROUTE_GLOBAL_DOCUMENT,
          params: { documentGid: document.gid },
          query,
        };
      default:
        console.error('ot-document-list -> getDocumentRoute -> unknown document list level: ', this.level);
        // throw new Error(`Unknown document list level: ${this.level}`);
        return { path: '/' };
    }
  }
  private getDocumentAssociationsRoute(document: DocumentListItem): RawLocation {
    switch (this.level) {
      case DocumentListLevel.Organisation:
        return {
          name: ROUTE_SETTINGS_ORG_DOCUMENT_ASSOCIATIONS,
          params: { orgId: this.organisationGid ?? '', documentGid: document.gid },
        };
      case DocumentListLevel.Project:
        return {
          name: ROUTE_PROJECT_DOCUMENT_ASSOCIATIONS,
          params: { projectGid: this.projectGid ?? '', documentGid: document.gid },
        };
      case DocumentListLevel.Contract:
        return {
          name: ROUTE_CONTRACT_DOCUMENT_ASSOCIATIONS,
          params: { projectGid: this.projectGid ?? '', contractGid: this.contractGid ?? '', documentGid: document.gid },
        };
      case DocumentListLevel.Workflow:
        return {
          name: ROUTE_WORKFLOW_DOCUMENT_ASSOCIATIONS,
          params: {
            projectGid: this.projectGid ?? '',
            contractGid: this.contractGid ?? '',
            claimGid: this.segmentInstanceGid ?? '',
            documentGid: document.gid,
          },
        };
      case DocumentListLevel.Global:
        return {
          name: ROUTE_GLOBAL_DOCUMENT_ASSOCIATIONS,
          params: { documentGid: document.gid },
        };
      default:
        console.error('ot-document-list -> getDocumentAssociationsRoute -> unknown document list level: ', this.level);
        // throw new Error(`Unknown document list level: ${this.level}`);
        return { path: '/' };
    }
  }
  private async removeDocumentAssociation(document: DocumentListItem, association: DocumentAssociation) {
    this.rowLoadingStates[document.gid] = true;
    console.log('ot-document-list -> removeDocumentAssociation -> document:  ', { document, association });
    const request = new PostUpdateDocumentAssociationsRequestModel();
    if (this.level === DocumentListLevel.Organisation && this.organisationGid) {
      request.removeOrganisationAssociations = [this.organisationGid];
    }
    if (this.level === DocumentListLevel.Project && this.projectGid) {
      request.removeProjectAssociations = [this.projectGid];
    }
    if (this.level === DocumentListLevel.Contract && this.contractGid) {
      request.removeContractAssociations = [this.contractGid];
    }
    await executeApi(
      () => this.api.documents().postUpdateDocumentAssociations(document.gid, request),
      'Update Document Associations',
    );
    this.loadResults(); // there's a small chance we'll ask for a page of data that doesn't exist anymore - if you're on the last item on the last page, you remove the association, the item will go, the page will not be there
    this.rowLoadingStates[document.gid] = false;
  }

  private createRemoveDocumentAssocationMenuItem(
    document: DocumentListItem,
    association: DocumentAssociation,
  ): IMenuOption {
    return {
      key: 'remove',
      label: `Remove from ${this.locationDescription}`,
      onClick: doc => this.removeDocumentAssociation(doc, association),
    };
  }
  private createOpenDocumentInAconexMenuItem(document: DocumentListItem): IMenuOption {
    const url = document.aconexDocumentMetadata
      ? getAconexDocumentLink({
          projectId: document.aconexDocumentMetadata.projectId,
          documentId: document.aconexDocumentMetadata.documentId,
          originalAconexSite: document.aconexDocumentMetadata.userSite ?? null,
        })
      : null;

    return {
      key: 'open-doc-in-aconex',
      label: 'Open in Aconex',
      onClick: () => url && window.open(url, '_blank'),
      disabled: !url,
    };
  }
  private createOpenMailInAconexMenuItem(document: DocumentListItem): IMenuOption {
    const url = document.aconexMailMetadata
      ? getAconexMailLink({
          projectId: document.aconexMailMetadata.projectId,
          mailId: document.aconexMailMetadata.mailId,
          originalAconexSite: document.aconexMailMetadata.userSite ?? null,
        })
      : null;
    return {
      key: 'open-mail-in-aconex',
      label: 'Open in Aconex',
      onClick: () => url && window.open(url, '_blank'),
      disabled: !url,
    };
  }

  private getDocumentOptionMenuItems(document: DocumentListItem): IMenuOption[] {
    const results: IMenuOption[] = [];
    if (this.mode === DocumentListMode.Display) {
      let association: DocumentAssociation | undefined = undefined;
      if (this.level === DocumentListLevel.Organisation) {
        association = document.organisationAssociations.find(a => areSame(a.associatedGid, this.organisationGid));
      }
      if (this.level === DocumentListLevel.Project) {
        association = document.projectAssociations.find(a => areSame(a.associatedGid, this.projectGid));
      }
      if (this.level === DocumentListLevel.Contract) {
        association = document.contractAssociations.find(a => areSame(a.associatedGid, this.contractGid));
      }
      if (association && association.availableActions.includes(OtUserAction.Remove)) {
        results.push(this.createRemoveDocumentAssocationMenuItem(document, association));
      }
      if (document.aconexDocumentMetadata) {
        results.push(this.createOpenDocumentInAconexMenuItem(document));
      }
      if (document.aconexMailMetadata) {
        results.push(this.createOpenMailInAconexMenuItem(document));
      }
    }
    return results;
  }

  private onCheckboxChange(document: DocumentListItem) {
    console.log('ot-document-list -> onCheckboxChange -> document:  ', {
      gid: document.gid,
      isSelected: document.isSelected,
    });
    // document.isSelected = !document.isSelected;
    if (document.isSelected) {
      this.selectedResults.push(document);
    } else {
      this.selectedResults = this.selectedResults.filter(x => x.gid !== document.gid);
    }
    this.$emit('update:selection', this.selectedResults);
  }

  // * LIFECYCLE
  private mounted() {
    if (this.level === DocumentListLevel.Organisation) {
      if (!this.organisationGid) {
        console.error('ot-document-list -> mounted -> when mode is organisation, organisationGid is required');
      }
    }
    if (this.level === DocumentListLevel.Project && !this.projectGid) {
      console.error('ot-document-list -> mounted -> when mode is project, projectGid is required');
    }
    if (this.level === DocumentListLevel.Contract) {
      if (!this.projectGid) {
        console.error('ot-document-list -> mounted -> when mode is contract, projectGid is required');
      }
      if (!this.contractGid) {
        console.error('ot-document-list -> mounted -> when mode is contract, contractGid is required');
      }
    }
    if (this.level === DocumentListLevel.Workflow) {
      if (!this.projectGid) {
        console.error('ot-document-list -> mounted -> when mode is workflow, projectGid is required');
      }
      if (!this.contractGid) {
        console.error('ot-document-list -> mounted -> when mode is workflow, contractGid is required');
      }
      if (!this.segmentInstanceGid) {
        console.error('ot-document-list -> mounted -> when mode is workflow, segmentInstanceGid is required');
      }
    }
    this.initTableColumns();
    this.loadResults();
  }
}
